import './Nav.scss';

import React from 'react';
import { useHistory } from 'react-router-dom';

import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import { default as BSNav } from 'react-bootstrap/Nav';

import axios from 'axios';

/**
 * This the component for the navigation bar.
 * @return {JSX.Element} - Nav bar component
 * @constructor
 */
const Nav = () => {
  const history = useHistory();

  const logout = () => {
    axios
      .post('/auth/logout')
      .then(() => history.push('/login'))
      .catch((err) => console.error(err));
  };

  return (
    <Navbar bg="dark" variant="dark" className={'app-header'}>
      <Image
        src={`${process.env.PUBLIC_URL}/images/logo.png`}
        alt="logo"
        width="50"
        height="50"
      />
      <BSNav>
        <BSNav.Link href="/">View NCRs/Returns</BSNav.Link>
        <BSNav.Link id="view_return" href="/view_return">
          View Standalone Returns
        </BSNav.Link>
        <BSNav.Link id="create" href="/create">
          Create NCR/Return
        </BSNav.Link>
        <BSNav.Link id="create_return" href="/create_return">
          Create Standalone Return
        </BSNav.Link>
      </BSNav>
      <BSNav className={'ml-auto'}>
        <BSNav.Link href="" onClick={logout}>
          Log out
        </BSNav.Link>
      </BSNav>
    </Navbar>
  );
};

export { Nav };
